import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  const viewloanpriority = {
    label: "View Loan Priority",
    pageLabel: "View Loan Priority",
    starting: true,
    url: "viewloanpriority",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            //isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Description",
            label: "Description",
            name: "Description",
            description: "Enter Description"
          },
          {
            inputType: "text",
            //isRequired: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Description",
            label: "",
            name: "Description",
            description: "Enter Description"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "Expand Notes",
            label: "Expand Notes",
            name: "Expand_Notes",
            description: "Expand Notes"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "Set Active",
            label: "Set Active",
            name: "Set_Active",
            description: "Set Active"
          },
      
    ]
  };
  export default viewloanpriority;